export const ENTRY_STATUSES = {
  WORKED: 'worked',
  LEAVE: 'leave',
  SICK: 'sick',
  HOLIDAY: 'holiday',
}

export const STATUS_OPTIONS = [
  {
    value: ENTRY_STATUSES.WORKED,
    label: 'Worked',
    shortLabel: 'Hours',
    marker: '',
    description: 'Enter the number of hours worked.',
  },
  {
    value: ENTRY_STATUSES.LEAVE,
    label: 'Leave',
    shortLabel: 'L',
    marker: 'L',
    description: 'Annual leave or other approved leave.',
  },
  {
    value: ENTRY_STATUSES.SICK,
    label: 'Sick leave',
    shortLabel: 'SL',
    marker: 'SL',
    description: 'Sick leave for the selected day.',
  },
  {
    value: ENTRY_STATUSES.HOLIDAY,
    label: 'Holiday',
    shortLabel: 'H',
    marker: 'H',
    description: 'Public or company holiday.',
  },
]

export const MAX_UPLOAD_BYTES = 6 * 1024 * 1024
export const ACCEPTED_FILE_EXTENSIONS = [
  '.pdf',
  '.png',
  '.jpg',
  '.jpeg',
  '.eml',
  '.msg',
  '.xlsx',
  '.xls',
  '.xlsm',
  '.xlsb',
  '.ods',
  '.csv',
  '.doc',
  '.docx',
]

export const MAX_RESUME_BYTES = 6 * 1024 * 1024
export const RESUME_ACCEPTED_FILE_EXTENSIONS = ['.pdf', '.doc', '.docx', '.rtf', '.txt']
